import { useState, useRef, useEffect } from 'react';

interface UseLazyLoadingOptions {
    threshold?: number;
    rootMargin?: string;
    triggerOnce?: boolean;
}

export function useLazyLoading(options: UseLazyLoadingOptions = {}) {
    const [isInView, setIsInView] = useState(false);
    const [hasTriggered, setHasTriggered] = useState(false);
    const elementRef = useRef<HTMLElement>(null);

    const {
        threshold = 0.1,
        rootMargin = '50px',
        triggerOnce = true
    } = options;

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsInView(true);
                    if (triggerOnce) {
                        setHasTriggered(true);
                        observer.disconnect();
                    }
                } else if (!triggerOnce) {
                    setIsInView(false);
                }
            },
            {
                threshold,
                rootMargin
            }
        );

        if (elementRef.current) {
            observer.observe(elementRef.current);
        }

        return () => observer.disconnect();
    }, [threshold, rootMargin, triggerOnce]);

    return {
        elementRef,
        isInView: triggerOnce ? (isInView || hasTriggered) : isInView
    };
}
